module.exports = __webpack_public_path__ + "static/media/esb-npa2023.657a1314.jpg";